import reportClientError from "./clientErrorReporter";

const ALLOWED_DETAILS = new Set([
  "permission_state", "accuracy_bucket", "status_code", "error_code",
  "booking_link_present", "booking_match", "route_ready", "elapsed_ms",
]);
const MAX_CHECKPOINTS = 30;

function accuracyBucket(value) {
  if (!Number.isFinite(value) || value < 0) return "unknown";
  if (value <= 25) return "high";
  if (value <= 100) return "medium";
  return "low";
}

export function createWorkModeJourneyTrace() {
  const traceId = `WMT-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
  const startedAt = Date.now();
  const checkpoints = [];
  let submitted = false;

  function checkpoint(name, outcome = "ok", details = {}) {
    if (submitted || checkpoints.length >= MAX_CHECKPOINTS) return;
    const item = {
      name: String(name).slice(0, 48),
      outcome: ["started", "ok", "blocked", "failed"].includes(outcome) ? outcome : "failed",
      elapsed_ms: Math.max(0, Date.now() - startedAt),
    };
    Object.entries(details || {}).forEach(([key, value]) => {
      if (!ALLOWED_DETAILS.has(key)) return;
      if (key === "accuracy_bucket") item[key] = accuracyBucket(value);
      else if (key === "status_code" && Number.isInteger(value)) item[key] = value;
      else if (key === "elapsed_ms" && Number.isFinite(value)) item[key] = Math.max(0, Math.round(value));
      else if (key === "booking_link_present" || key === "route_ready") item[key] = Boolean(value);
      else if (key === "booking_match" && ["matched", "mismatched", "unavailable"].includes(value)) item[key] = value;
      else if (key === "permission_state" && ["prompted", "granted", "denied", "unavailable", "unknown"].includes(value)) item[key] = value;
      else if (key === "error_code" && ["permission_denied", "timeout", "position_unavailable", "invalid_location", "place_search_unavailable", "centre_catalogue_unavailable", "no_results", "network", "http_error", "invalid_response", "unknown"].includes(value)) item[key] = value;
    });
    checkpoints.push(item);
  }

  async function finish(outcome, message = "Work mode route journey completed.") {
    if (submitted) return null;
    checkpoint("journey_finished", outcome === "failed" ? "failed" : "ok");
    submitted = true;
    const report = await reportClientError({
      category: "work_mode_trace",
      component: "WorkMode",
      message: String(message).slice(0, 500),
      extras: {
        trace_id: traceId,
        journey_outcome: outcome === "failed" ? "failed" : "completed",
        checkpoints: checkpoints.slice(0, MAX_CHECKPOINTS),
      },
    });
    return report;
  }

  return { checkpoint, finish };
}
